import { createQuery } from 'react-query-kit';

import { PostGreSQLInterval, privateApi } from 'api';

export type GetFormParams = {
  id: string;
};

export type Form = {
  id: string;
  name: string;
  duration_valid?: PostGreSQLInterval;
  link: string;
  tenant_form: {
    tenant_id: string;
    message_template_set: MessageTemplateSet | null;
  };
};

async function getForm({ id }: GetFormParams) {
  // make api call
  const result = await privateApi.get<Form>(`${import.meta.env.VITE_API_BASE_URL}/forms/${id}`, {});

  return result.data;
}

const useGetForm = createQuery<Form, GetFormParams, Error>({
  queryKey: ['form'],
  fetcher: (variables) => getForm(variables),
});

export { useGetForm };
